<template>
  <div class="Site IndexBox">
    <div class="ScrollBox">
      <van-nav-bar fixed :border="false" :title="$t('user.vipl')" style="background-color: #37774C;" />

      <div class="container">
        <!-- <div class="indicator-scroll" ref="indicatorScroll">
          <div class="indicator-container">
            <div v-for="(item, index) in InitData.UserGradeList" :key="'step-' + index" class="step">
              <div class="progress-group">
                <div class="dot" :class="{ 'active': current >= index }"></div>
                <div v-if="index < InitData.UserGradeList.length - 1" class="line"
                  :class="{ 'active': current > index }"></div>
              </div>
              <div class="step-label" :class="{ 'active': current === index }">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div> -->

        <!-- 卡片轮播区域 -->
        <div class="carousel-wrapper"> 
          <van-swipe ref="swipeRef" :initial-swipe="current" :loop="false" :show-indicators="false"
            @change="onSwipeChange" class="preview-swipe">
            <van-swipe-item v-for="(item, index) in orderedGradeList" :key="'card-' + (item.grade || index)">
              <div class="vip-card" :class="{ 'active': current === index }" :style="{
                backgroundImage: getVipImageUrl(item, index),
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }">
                <div class="card-content">
                  <h3>{{ $t("vip.list.text[10]") }}：
                    {{ item.grade == UserInfo.vip_level ? UserInfo.day : 0 }}/{{ $t("vip.list.text[9]") }}</h3>
                  <p>{{ $t("vip.list.text[7]") }}：
                    <span v-if="UserInfo.vip_level == item.grade">{{UserInfo.fmt_etime}}</span>
                    <span v-else-if="UserInfo.vip_level != item.grade && item.grade == 1">{{2 + $t("vip.list.text[9]")}}</span>
                    <span v-else-if="UserInfo.vip_level != item.grade && item.grade == 2">{{7 + $t("vip.list.text[9]")}}</span>
                    <span v-else>{{2 + $t("vip.list.text[8]")}}</span></p>
                  <div class="vip-level">{{ item.name }}</div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>

          <!-- 切换按钮 -->
          <div class="nav-btn left" :class="{ 'disabled': current === 0 }" @click="swipePrev" aria-label="UP">
            <van-icon name="arrow-left" />
          </div>
          <div class="nav-btn right" :class="{ 'disabled': current === orderedGradeList.length - 1 }"
            @click="swipeNext" aria-label="DOWN">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>

      <div class="vip-table" v-if="currentGrade"> 
        <div v-if="isLockedLevel(currentGrade) && !isCurrentUserGrade(currentGrade)"
        style="background-image: url('./static/images/vip/bottom-en@2x.png');background-size: 292px 66px;color:#fff; width:292px;height:66px;position: absolute;margin-top: -25px; left: 50%;transform: translateX(-50%);padding-top: 18px;text-align: center;">
          <span v-if="(current)>0" style="font-size:16px">{{ currentGrade.amount }}{{ InitData.currency }}</span>
              {{ isBaseGrade(currentGrade) ? $t("task.index[6]") : $t("task.index[2]") }}
        </div>
        <div v-else-if="currentGrade.state == 3 && !isCurrentUserGrade(currentGrade)"
        style="background-image: url('./static/images/vip/bottom-en@2x.png');background-size: 292px 66px;color:#fff; width:292px;height:66px;position: absolute;margin-top: -25px; left: 50%;transform: translateX(-50%);padding-top: 18px;text-align: center;">
              {{  $t("task.index[7]") }}
        </div>
        <div v-else @click="submitBuy(currentGrade.amount, currentGrade.grade, currentGrade.name, currentGrade.state)"
        style="background-image: url('./static/images/vip/bottom@2x.png');background-size: 292px 66px;color:#fff; width:292px;height:66px;line-height:55px;text-align: center;position: absolute;margin-top: -25px; left: 50%;transform: translateX(-50%);z-index: 1;">
          <span style="font-size:16px">{{ currentGrade.amount }}{{ InitData.currency }}</span>
              {{ isBaseGrade(currentGrade) ? $t("task.index[6]") : $t("task.index[2]") }}
        </div>
        <div class="vip-content-wrapper">
          <div class="vip-content-body" :class="{ 'is-blurred': shouldBlurContent(currentGrade) }">
          <h2 style="padding:10px 0">
            {{ $t('vip.desc[0]', { level: currentGrade.name }) }}
          </h2>
          <h4 style="padding:5px 0">{{ $t('vip.desc[1]') }}</h4>
          <div class="vant-table">
            <table class="table">
              <tr>
                <th class="th">{{ $t('vip.desc[2]') }}</th>
                <th class="th">{{ $t('vip.desc[3]') }}</th>
                <th class="th">{{ $t('vip.desc[23]') }}</th>
                <th class="th">{{ $t('vip.desc[4]') }}</th>
              </tr>
              <tr class="list-tr">
                <td>{{ $t('vip.desc[5]') }}</td>
                <td>{{ currentGrade.number }}</td>
                <td>
                  {{ this.moneyFormat(currentGrade.commission) }}
                </td>
                <td>{{ this.moneyFormat(currentGrade.income) }}</td>
              </tr>
              <!-- <tr class="list-tr" v-if="this.current == 0">
              <td>{{ $t('vip.desc[22]') }}</td>
              <td>{{ InitData.UserGradeList[current].number * 4 }}</td>
              <td>
                {{ this.moneyFormat(InitData.UserGradeList[current].number * InitData.UserGradeList[current].commission * 4) }}
              </td>
              <td>{{ InitData.UserGradeList[current].amount *4 }}</td>
            </tr> -->
              <!-- <tr class="list-tr" v-if="this.current != 0">
              <td>{{ $t('vip.desc[6]') }}</td>
              <td>{{ InitData.UserGradeList[current].number * 30 }}</td>
              <td>
                {{ this.moneyFormat(InitData.UserGradeList[current].number * InitData.UserGradeList[current].commission * 30) }}
              </td>
            </tr>
            <tr class="list-tr" v-if="this.current != 0">
              <td>{{ $t('vip.desc[7]') }}</td>
              <td>{{ InitData.UserGradeList[current].number * 365 }}</td>
              <td>
                {{ this.moneyFormat(InitData.UserGradeList[current].number * InitData.UserGradeList[current].commission * 365) }}
              </td>
            </tr> -->
            </table>
            <div style="padding:5px 0" v-if="isBaseGrade(currentGrade)">
              <h3>{{ $t('vip.desc[24]') }}</h3>
              <!-- <div>1.{{ InitData.UserGradeList[current].name }} members are temporary employees hired by Bozell. Temporary members can work for {{this.current == 0?4:365}} days through promotion tasks posted by Bozell and receive {{this.current == 0?this.moneyFormat(InitData.UserGradeList[current].income * 4):this.moneyFormat(InitData.UserGradeList[current].income * 365)}}{{ InitData.currency }} commission income per day.</div>
            <div>2. Each {{ InitData.UserGradeList[current].name }} member can receive {{this.current == 0?this.moneyFormat(InitData.UserGradeList[current].income * 4):this.moneyFormat(InitData.UserGradeList[current].income * 365)}}{{ InitData.currency }} commission for tasks during the {{this.current == 0?4:30}}-day working period.</div>
            <div>3. {{ InitData.UserGradeList[current].name }} members are limited to {{this.current == 0?4:365}}-day temporary work and do not enjoy any rights and interests of Bozell formal employees.</div>
            <div>4. Bozell has the final right of interpretation. If you have any questions, please contact the Human Resources Director.</div> -->
              <div v-html="$t('vip.desc[25]')"></div>
            </div>
            <div v-else>
              <h4 style="padding:5px 0">{{ $t('vip.desc[8]') }}</h4>
              <div class="vant-table">
                <table class="table">
                  <tr>
                    <th class="th">{{ $t('vip.desc[9]') }}</th>
                    <th class="th">{{ $t('vip.desc[10]') }}</th>
                    <th class="th">{{ $t('vip.desc[11]') }}</th>
                  </tr>
                  <tr class="list-tr">
                    <td>{{ $t('vip.desc[12]') }}</td>
                    <td>{{ currentGrade.spread1 }}%</td>
                    <td>{{ 
                      
                        currentGrade.amount * 
                        currentGrade.spread1 / 
                        100
                      
                    }}</td>
                  </tr>
                  <tr class="list-tr">
                    <td>{{ $t('vip.desc[13]') }}</td>
                    <td>{{ currentGrade.spread2 }}%</td>
                    
					  <td>{{ 
					    
					      currentGrade.amount * 
					      currentGrade.spread2 / 
					      100
					    
					  }}</td>
                  </tr>
                  <tr class="list-tr">
                    <td>{{ $t('vip.desc[14]') }}</td>
                    <td>{{ currentGrade.spread3 }}%</td>
                    <td>{{ 
                      
                        currentGrade.amount * 
                        currentGrade.spread3 / 
                        100
                      
                    }}</td>
                  </tr>
                </table>
              </div>
              <h4 style="padding:5px 0">{{ $t('vip.desc[28]') }}</h4>
              <div class="vant-table">
                <table class="table">
                  <tr class="list-tr">
                    <td>
                      <div class="list-div" v-html="$t('vip.desc[29]')"></div>
                    </td>
                  </tr>
                </table>
              </div>
              <h4 style="padding:5px 0">{{ $t('vip.desc[15]') }}</h4>
              <div class="vant-table">
                <table class="table">
                  <tr>
                    <th class="th">{{ $t('vip.desc[16]') }}</th>
                    <th class="th">{{ $t('vip.desc[17]') }}</th>
                    <th class="th">{{ $t('vip.desc[18]') }}</th>
                  </tr>
                  <tr class="list-tr">
                    <td>{{ $t('vip.desc[19]') }}</td>
                    <td>{{ isBaseGrade(currentGrade) ? 0 : InitData.setting.rebate1 }}%</td>
                    <td>{{ isBaseGrade(currentGrade) ? 0 : this.moneyFormat(currentGrade.commission *
                      currentGrade.number * InitData.setting.rebate1 / 100) }}</td>
                  </tr>
                  <tr class="list-tr">
                    <td>{{ $t('vip.desc[20]') }}</td>
                    <td>{{ isBaseGrade(currentGrade) ? 0 : InitData.setting.rebate2 }}%</td>
                    <td>{{ isBaseGrade(currentGrade) ? 0 : this.moneyFormat(currentGrade.commission *
                      currentGrade.number * InitData.setting.rebate2 / 100) }}</td>
                  </tr>
                  <tr class="list-tr">
                    <td>{{ $t('vip.desc[21]') }}</td>
                    <td>{{ isBaseGrade(currentGrade) ? 0 : InitData.setting.rebate3 }}%</td>
                    <td>{{ isBaseGrade(currentGrade) ? 0 : this.moneyFormat(currentGrade.commission *
                      currentGrade.number * InitData.setting.rebate3 / 100) }}</td>
                  </tr>
                </table>
              </div>
              <h4 style="padding:5px 0">{{ $t('vip.desc[26]') }}</h4>
              <div>
                <table class="table">
                  <tr class="list-tr">
                    <td>
                      <div class="list-div" v-html="$t('vip.desc[27]')"></div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div style="height: 60px;"></div>
        <!-- <div style="position: fixed;left: 0px; bottom: 60px;width: 100%; text-align: center;padding: 10px 0;">
          <p v-if="InitData.UserGradeList[current].state == 3">
            <van-button size="small" round block
              style="float: left; left: 50%;transform: translateX(-50%);color: #fff;font-size: 16px;background-color:#999;border: none;box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.3);width: 300px;">
              {{ InitData.UserGradeList[current].amount }}{{ InitData.currency }} Stay tuned</van-button>
          </p>
          <p v-else-if="UserInfo.vip_level && current >= UserInfo.vip_level">
            <van-button size="small" round block
              style="float: left; left: 50%;transform: translateX(-50%);color: #fff;font-size: 16px;background: linear-gradient(to right,var(--theme-shallow-color), var(--theme-color));border: none;box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.3);width: 300px;"
              @click="
                submitBuy(InitData.UserGradeList[current].amount, InitData.UserGradeList[current].grade, InitData.UserGradeList[current].name, InitData.UserGradeList[current].state)
                ">{{ InitData.UserGradeList[current].amount }}{{ InitData.currency }}
              {{ $t("task.index[2]") }}</van-button>
          </p>
          <p v-else-if="!UserInfo.vip_level || UserInfo.vip_level == 0">
            <van-button size="small" round block
              style="float: left; left: 50%;transform: translateX(-50%);color: #fff;font-size: 16px;background: linear-gradient(to right,var(--theme-shallow-color), var(--theme-color));border: none;box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.3);width: 300px;"
              @click="
                submitBuy(InitData.UserGradeList[current].amount, InitData.UserGradeList[current].grade, InitData.UserGradeList[current].name, InitData.UserGradeList[current].state)
                ">{{ InitData.UserGradeList[current].amount }}{{ InitData.currency }}
              {{ $t("task.index[2]") }}</van-button>
          </p>
        </div> -->
      </div>
    </div>
    <Footer />
    
    <van-popup v-model="showVipNotice" style="background: transparent; text-align: center">
      <dl style="background: url('./static/images/vip/tz_bg1.png') 100% 100%;background-size: 270px 450px;width: 270px;height: 450px; border-radius: 5px;padding-top: 230px;">
        <!-- <img :src="`./static/images/home/tf_bg.png`" width="100%" height="115px"> -->
        <dt style="margin:0 25px;width: 218px;height: 115px;background: #FFE3E3;border-radius: 15px 15px 15px 15px;padding:5px;border: 1px solid #EAEAEA;margin-top: 30px;display: -webkit-box; overflow: hidden; text-overflow: ellipsis;-webkit-line-clamp: 6;-webkit-box-orient: vertical;">{{ $t('home.title[6]')
            }}</dt>
        <dt style="margin-top: 20px;">
          <van-button round @click="goTaskList"
            style="font-size: 18px;background-color:#37774C; width: 80%;color:#fff">{{ $t('home.title[5]')
            }}</van-button>
        </dt>
      </dl>
      <a class="close" href="javascript:;" @click="showVipNotice = false">
        <van-icon name="clear" color="rgba(255,255,255,.8)" size="2.5rem" />
      </a>
    </van-popup>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Icon } from 'vant';

const GRADE_DISPLAY_ORDER = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
const EQUIVALENT_GRADE_GROUPS = [
  [3, 4],
  [5, 6],
];

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon
  },
  data() {
    return {
      current: 0,
      memberLevel: "member1",
      showVipNotice:false,
      hasSyncedCurrent: false
    };
  },
  computed: {
    orderedGradeList() {
      const sourceList = Array.isArray(this.InitData.UserGradeList) ? this.InitData.UserGradeList : [];
      if (!sourceList.length) {
        return [];
      }
      return [...sourceList].sort((a, b) => {
        const rankA = this.getGradeRank(a && a.grade);
        const rankB = this.getGradeRank(b && b.grade);
        if (rankA !== rankB) {
          return rankA - rankB;
        }
        return Number(a && a.grade) - Number(b && b.grade);
      });
    },
    currentGrade() {
      return this.orderedGradeList[this.current] || null;
    }
  },
  watch: {
    'InitData.UserGradeList': {
      immediate: true,
      handler() {
        this.syncCurrentLevel(true);
      }
    },
    'UserInfo.vip_level': {
      immediate: true,
      handler() {
        this.syncCurrentLevel(true);
      }
    }
  },
  mounted() {
    this.scrollToActiveDot();
    window.addEventListener('resize', this.scrollToActiveDot);
  },
  created() {
    this.$Model.GetUserInfo();
    this.syncCurrentLevel();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scrollToActiveDot);
  },
  methods: {
    getGradeRank(grade) {
      const normalizedGrade = Number(grade);
      if (!normalizedGrade) {
        return -1;
      }
      const rank = GRADE_DISPLAY_ORDER.indexOf(normalizedGrade);
      return rank === -1 ? GRADE_DISPLAY_ORDER.length + normalizedGrade : rank;
    },
    canPreviewNextTier(userGrade, itemGrade) {
      const userG = Number(userGrade);
      const itemG = Number(itemGrade);
      if (userG !== 4) {
        return false;
      }
      const userRank = this.getGradeRank(userG);
      const itemRank = this.getGradeRank(itemG);
      const previewMaxRank = this.getGradeRank(6);
      if (userRank === -1 || itemRank === -1 || previewMaxRank === -1) {
        return false;
      }
      return itemRank > userRank && itemRank <= previewMaxRank;
    },
    getUserVipGrade() {
      if (!this.UserInfo || typeof this.UserInfo !== 'object') {
        return 0;
      }
      return Number(this.UserInfo.vip_level || 0);
    },
    isCurrentUserGrade(item) {
      if (!item) {
        return false;
      }
      const userGrade = this.getUserVipGrade();
      if (!userGrade) {
        return false;
      }
      return userGrade === Number(item.grade);
    },
    canViewGradeContent(userGrade, itemGrade) {
      const userG = Number(userGrade || 0);
      const itemG = Number(itemGrade || 0);
      if (!itemG) {
        return false;
      }
      if (userG <= 6 && itemG <= 6) {
        return true;
      }
      if (!userG) {
        return this.getGradeRank(itemG) <= this.getGradeRank(1);
      }
      if (userG === itemG) {
        return true;
      }
      if (this.isEquivalentGrade(userG, itemG)) {
        return true;
      }
      const userRank = this.getGradeRank(userG);
      const itemRank = this.getGradeRank(itemG);
      if (userRank !== -1 && itemRank !== -1 && userRank >= itemRank) {
        return true;
      }
      if (this.canPreviewNextTier(userG, itemG)) {
        return true;
      }
      return false;
    },
    isEquivalentGrade(gradeA, gradeB) {
      const a = Number(gradeA);
      const b = Number(gradeB);
      if (!a || !b || a === b) {
        return false;
      }
      return EQUIVALENT_GRADE_GROUPS.some(group => group.includes(a) && group.includes(b));
    },
    shouldBlurContent(item) {
      if (!item) {
        return false;
      }
      if (!this.UserInfo || typeof this.UserInfo !== 'object') {
        return false;
      }
      const userGrade = this.getUserVipGrade();
      const itemGrade = Number(item.grade || 0);
      if (this.canViewGradeContent(userGrade, itemGrade)) {
        return false;
      }
      return true;
    },
    findClosestVisibleIndexByLevel(level) {
      const list = this.orderedGradeList;
      if (!list.length) {
        return 0;
      }

      const currentLevel = Number(level || 0);
      if (!currentLevel) {
        return 0;
      }

      const exactIndex = list.findIndex(item => Number(item && item.grade) === currentLevel);
      if (exactIndex !== -1) {
        return exactIndex;
      }

      const userRank = this.getGradeRank(currentLevel);
      let fallbackIndex = -1;
      list.forEach((item, index) => {
        const itemGrade = Number(item && item.grade);
        if (this.getGradeRank(itemGrade) <= userRank) {
          fallbackIndex = index;
        }
      });

      return fallbackIndex === -1 ? 0 : fallbackIndex;
    },
    syncCurrentLevel(force = false) {
      const list = this.orderedGradeList;
      if (!list.length) {
        this.current = 0;
        return;
      }

      if (!force && this.hasSyncedCurrent && this.current >= 0 && this.current < list.length) {
        return;
      }

      const nextIndex = this.findClosestVisibleIndexByLevel(this.UserInfo.vip_level);
      this.current = nextIndex;
      this.memberLevel = "member" + this.current;
      this.hasSyncedCurrent = true;

      this.$nextTick(() => {
        if (this.$refs.swipeRef && typeof this.$refs.swipeRef.swipeTo === 'function') {
          this.$refs.swipeRef.swipeTo(nextIndex, { immediate: true });
        }
      });
    },
    getVipImageIndex(item, index) {
      const grade = Number(item && item.grade);
      if (grade === 12 || grade === 13 || grade === 14) {
        return grade;
      }
      if (grade >= 1 && grade <= 11) {
        return grade - 1;
      }
      return index;
    },
    getVipImageUrl(item, index) {
      return `url(./static/images/vip/VIP${this.getVipImageIndex(item, index)}.png)`;
    },
    isLockedLevel(item) {
      if (!item) {
        return false;
      }
      const userLevel = this.getUserVipGrade();
      const itemGrade = Number(item.grade || 0);
      if (!userLevel || !itemGrade) {
        return false;
      }
      if (userLevel === itemGrade) {
        return false;
      }
      const userRank = this.getGradeRank(userLevel);
      const itemRank = this.getGradeRank(itemGrade);
      if (userRank === -1 || itemRank === -1) {
        return userLevel > itemGrade;
      }
      return userRank > itemRank;
    },
    isBaseGrade(item) {
      return Number(item && item.grade) === 1;
    },
    goTaskList(){
      this.$router.push(`/myTask`);
    },
    scrollToActiveDot() {
      this.$nextTick(() => {
        const container = this.$refs.indicatorScroll;
        if (!container) return;

        const stepIndex = this.current;
        const steps = container.querySelectorAll('.step');
        const step = steps[stepIndex];

        if (step) {
          const containerCenter = container.offsetWidth / 2;
          const stepPosition = step.offsetLeft + step.offsetWidth / 2;
          const scrollLeft = stepPosition - containerCenter;

          container.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
      });
    },
    onSwipeChange(index) {
      this.current = index;
      this.scrollToActiveDot();
    },
    swipePrev() {
      if (this.current > 0) {
        this.$refs.swipeRef.prev();
      }
    },
    swipeNext() {
      if (this.current < this.orderedGradeList.length - 1) {
        this.$refs.swipeRef.next();
      }
    },
    moneyFormat(num) {
      return new Intl.NumberFormat().format(Number(num).toFixed(2));
    },
    handleSlideChange() {
      //console.log(this.$refs.mySwiper.swiper.activeIndex);
      // 这里会在slide变化时被调用
      this.current = this.$refs.mySwiper.swiper.activeIndex;
      //this.current = this.$refs.mySwiper.swiper.activeIndex;
      this.memberLevel = "member" + (this.$refs.mySwiper.swiper.activeIndex + 1);
    },
    changeItem(e) {
      this.current = e;
      this.memberLevel = "member" + (e + 1);
    },
    toNotice() {
      // this.$router.push("/user/recharge1");
      this.$router.push('/user/recharge1?amount=' + this.amount)
    },
    submitBuy(amount, grade, name, state) {
      const buyItem = this.orderedGradeList.find(item => Number(item && item.grade) === Number(grade));
      if (buyItem && this.isLockedLevel(buyItem)) {
        return;
      }
      this.amount = amount;
      const isOwnGrade = buyItem && this.isCurrentUserGrade(buyItem);
      if (state == 3 && !isOwnGrade) {
        this.$dialog
          .alert({
            message: this.$t('vip.title[2]'),
          })
          .then(() => {
            // on close
          });
        return;
      }
      var html = this.$t("vip.dialog[0]", { amount: amount, name: name });
      this.$Model.GetUserInfo((data) => {
        if (data.code == 1) {
          if (data.info.vip_level > grade) {
            this.$toast.fail(
              this.$t("vip.dialog[1]", {
                currname: data.info.useridentity,
                name: name,
              })
            );
          } else {
            if (data.info.vip_level == grade) {
              html = this.$t("vip.dialog[2]", { amount: amount, name: name });
            }
            this.$dialog
              .confirm({
                message: html,
                confirmButtonText: this.$t("vip.index[1]"),
                cancelButtonText: this.$t("vip.index[0]"),
              })
              .then(() => {
                this.$Model.BuyVip({ grade: grade }, (data) => {
                  console.log(data);
                  if (data.code == 1) {
                    this.$Model.GetUserInfo();
                    this.showVipNotice=true;
                  }
                  if (data.code == 2) {
                    this.$router.push('/user/recharge?amount=' + amount)
                  }
                });
              })
              .catch(() => { });
          }
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 10px 0 30px;
  max-width: 100%;
  overflow-x: hidden;
}

.indicator-scroll {
  overflow-x: auto;
  padding-bottom: 10px;
  scrollbar-width: none;
  margin: 0 40px;
}

.indicator-scroll::-webkit-scrollbar {
  display: none;
}

.indicator-container {
  display: inline-flex;
  padding: 20px 10px 0px;
  min-width: 100%;
}

.step {
  display: flex;
  flex-direction: column;
  margin: 0 1px;
}

.progress-group {
  display: flex;
  align-items: center;
  height: 12px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ebedf0;
  transition: all 0.3s;
  flex-shrink: 0;
  border: 2px solid white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.line {
  width: 36px;
  height: 2px;
  background: #ebedf0;
  margin: 0 -4px;
  flex-shrink: 0;
}

.dot.active {
  background: #dd564a;
  transform: scale(1.1);
}

.line.active {
  background: #dd564a;
}

.step-label {
  font-size: 12px;
  // color: #999;
  color: #fff;
  margin-top: 8px;
  transition: all 0.3s;
  white-space: nowrap;
  font-weight: 500;
}

.step-label.active {
  color: #dd564a;
  font-weight: bold;
  transform: scale(1.1);
}

.carousel-wrapper {
  position: relative;
  padding: 0 30px;
}

.preview-swipe {
  overflow: visible;
}

.preview-swipe .van-swipe-item {
  width: 70%;
  transition: transform 0.3s ease;
  // padding: 0 5px;
  box-sizing: border-box;
}

.preview-swipe .van-swipe-item:not(.van-swipe-item--active) {
  transform: scale(0.95);
  //opacity: 0.8;
  filter: blur(0.3px);
}

.vip-card {
  width: 100%;
  height: 190px;
  border-radius: 12px;
  padding: 20px;
  color: white;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  font-size: 15px;
  will-change: transform, filter;
}

.vip-card.active {
  // box-shadow: 0 8px 20px rgba(0,0,0,0.2);
  transform: scale(1.05);
  z-index: 2;
}

.card-content h3 {
  padding-top: 70px;
  padding-left: 10px;
  font-size: 18px;
  margin-bottom: 5px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2)
}

.vip-level {
  position: absolute;
  top: 25px;
  left: 20px;
  background: rgba(255, 255, 255, 0.15);
  padding: 5px 10px;
  border-radius: 15px;
  backdrop-filter: blur(2px);
  font-size:20px;
}

.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  transition: all 0.3s ease;
}

.nav-btn.left {
  left: 5px;
}

.nav-btn.right {
  right: 5px;
}

.nav-btn.disabled {
  opacity: 0.3;
  pointer-events: none;
}

@media (max-width: 768px) {
  .indicator-container {
    padding: 10px 10px 0px;
  }

  .step-label {
    font-size: 10px;
    margin-top: 6px;
  }

  .line {
    width: 36px;
    margin: 0 -3px;
  }

  .preview-swipe .van-swipe-item {
    width: 85%;
  }

  .vip-card {
    height: 160px;
    padding: 15px;
  }
}

.Site {
  background-color: #37774C;
}

.IndexBox {
  overflow: hidden;
  padding-top: 2.8rem;
}

/deep/.van-nav-bar__title {
  color: #000;
}

/deep/.van-rate__icon {
  color: #fff;
}

.icon-color-1 {
  background-image: linear-gradient(#72aefe, #4896ff);
}

.icon-color-2 {
  background-image: linear-gradient(#5ff9d7, #39debd);
}

.icon-color-3 {
  background-image: linear-gradient(#ffd155, #ffbc04);
}

.icon-color-4 {
  background-image: linear-gradient(#ff808b, #ff6872);
}

.list-div {
  text-align: justify;
}

.card-content p {
  padding: 5px 0;
  padding-left: 10px;
  font-size:16px;
}

.vant-table {
  .table {
    width: 100%;
    text-align: center;

    .th {
      height: 1.074074rem;
      line-height: 1.074074rem;
      background-color: #37774C;
      // text-align: left;
      border: 1px solid #37774C;
      border-collapse: collapse;
      color: #fff;
      /* 移除表格内边框间的间隙 */
    }

    .list-tr {
      height: 1.074074rem;
      line-height: 1.074074rem;
      border-bottom: 1px solid #ffdcdf; // 增加边框

      td {
        border: 1px solid #37774C;
        border-collapse: collapse;
        color: #4f4b4b;
        /* 移除表格内边框间的间隙 */
      }
    }

    .list-tr:nth-of-type(1) {
      border-top: 1px solid #ffdcdf; // 增加边框
    }

    // .list-tr:nth-child(2n) {
    //   background-color: #33333b;
    // }
  }
}

.vip-table {
  background: #FFFFFF;
  border-radius: 23px 23px 0px 0px;
  min-height: calc(100% - 200px);
}

.line-with-arrow {
  z-index: 999;
  position: relative;
  height: 2px;
  /* 横线的高度 */
  background-color: #fff;
  /* 横线的颜色 */
}

.line-with-arrow::before {
  content: "";
  position: absolute;
  left: 50%;
  top: -5px;
  /* 箭头的位置，向上移动的距离 */
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 5px 5px 5px;
  /* 上边框宽度 */
  border-color: transparent transparent #fff transparent;
  /* 上边框颜色，左到右分别是箭头颜色、透明、透明、透明 */
  transform: translateX(-50%);
  /* 将伪元素居中 */
}

.swiper-slide {
  width: 80%;
}

/deep/.van-step--horizontal .van-step__circle-container {
  position: absolute;
  top: 30px;
  z-index: 1;
  padding: 0 8px;
  background-color: #37774C;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: -2px;
}

/deep/.van-step--horizontal .van-step__icon {
  font-size: 16px;
}

/deep/.van-nav-bar__content {
  background: linear-gradient(to right, $theme-shallow-color, $theme-color);
  color: #fff;
}

/deep/.van-nav-bar__title {
  color: #fff;
}

/deep/.van-nav-bar .van-icon {
  color: #fff !important;
}

.vip-content-wrapper {
  position: relative;
  padding: 35px 15px 0 15px;
  overflow: hidden;
}

.vip-content-body {
  position: relative;

  &.is-blurred {
    filter: blur(10px);
    -webkit-filter: blur(10px);
    user-select: none;
    pointer-events: none;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.55);
      z-index: 10;
    }
  }
}
</style>
